import { render } from "./FiltersForm.vue?vue&type=template&id=6c5d649b"
import script from "./FiltersForm.vue?vue&type=script&lang=js"
export * from "./FiltersForm.vue?vue&type=script&lang=js"

import "./FiltersForm.vue?vue&type=style&index=0&id=6c5d649b&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__